export const getters = {
  getChats: (state) => state.chats.data,
  getSelectedRoom: (state) => state.selectedRoom,
  getRooms: (state) => state.room.data,
  getHeader: (state) => state.header,
  shouldIMoveScroll: (state) => state.shouldIMoveScroll,
  getBubbleCounts: (state) => state.bubbleCounts,
  getRoomPageInfo: (state) => {
    const { page, limit, totalPage, roomType, orderTab, nextId } = state.room;
    return { page, limit, totalPage, roomType, orderTab, nextId };
  },
  getImageUploadState: (state) => {
    return state.imageUploadState;
  },
  getActiveCount: (state) => state.activeCount // 채팅 뉴마크 관련
};

export default getters;
